import { cn } from "@/lib/utils";
import { Toggle } from "../toggle";
import { forwardRef } from "react";

interface RunImmediatelyInputProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  description?: string;
}

export const RunImmediatelyInput = forwardRef<
  HTMLDivElement,
  RunImmediatelyInputProps
>(({ value, onChange, onClick, disabled, description }, ref) => {
  const isSelected = value === true;
  return (
    <div
      onClick={(e) => {
        if (!disabled) {
          onChange?.(true);
          onClick?.(e);
        }
      }}
      className={cn(
        "flex items-center gap-2 cursor-pointer",
        disabled && "opacity-50 cursor-not-allowed",
      )}
      ref={ref}
    >
      <Toggle
        variant={"round_dot"}
        size="xs"
        pressed={isSelected}
        type="button"
        onPressedChange={(pressed) => {
          if (pressed) {
            onChange?.(true);
          }
        }}
        disabled={disabled}
      />
      <div className="flex flex-col">
        <h2>Run Immediately</h2>
        <span className="text-xs text-gray-500">
          {description ?? "Deploy the component right away"}
        </span>
      </div>
    </div>
  );
});

export const ScheduleSpecificInput = forwardRef<
  HTMLDivElement,
  RunImmediatelyInputProps
>(({ value, onChange, onClick, disabled }, ref) => {
  const isSelected = value === false;
  return (
    <div
      onClick={(e) => {
        if (!disabled) {
          onChange?.(false);
          onClick?.(e);
        }
      }}
      className={cn(
        "flex items-center gap-2 cursor-pointer",
        disabled && "opacity-50 cursor-not-allowed",
      )}
      ref={ref}
    >
      <Toggle
        variant={"round_dot"}
        size="xs"
        pressed={isSelected}
        type="button"
        onPressedChange={(pressed) => {
          if (pressed) {
            onChange?.(false);
          }
        }}
        disabled={disabled}
      />
      <div className={"flex flex-col"}>
        <h2 className={cn(disabled && "opacity-50")}>
          Schedule for a Specific Time
        </h2>
        <span className="text-xs text-gray-500">
          Choose a date and time for deployment
        </span>
      </div>
    </div>
  );
});
